import React from 'react';
import { QUERY_IDS } from '@services';
import LinkChd from '../LinkChd';

type Props = {
  linkStyles?: string
  link?: any
  colorTheme?: string
}

function ChdButton({
  linkStyles, link, colorTheme = '',
}: Props) {
  let buttonThemeStyles = '';
  if (link?.queryId === QUERY_IDS.MILLION_MATCH_QUERY_ID) {
    buttonThemeStyles = 'million-match-button';
  } else if (colorTheme === 'green') {
    buttonThemeStyles = 'bg-chdGreen-light hover:bg-chdGreen-hover';
  } else if (colorTheme === 'blue') {
    buttonThemeStyles = 'bg-chdBlue-light hover:bg-[#3FB6E8] border-[#0080A3]';
  }

  const newLinkStyles = `${linkStyles} ${buttonThemeStyles}`;

  return (
    <LinkChd
      linkStyles={`basis-[45%] leading-[20px] xl:basis-auto flex flex-1 items-center justify-center text-black uppercase font-bold tracking-[0.15em] py-4 px-2 text-center ${newLinkStyles}`}
      link={link}
    />
  );
}

ChdButton.defaultProps = {
  link: {},
  linkStyles: '',
  colorTheme: '',
};

export default ChdButton;
